import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { sv } from "date-fns/locale";
import { DateTimePicker , MuiPickersUtilsProvider,KeyboardDateTimePicker } from '@material-ui/pickers';
import IconButton from "@material-ui/core/IconButton";
import moment from 'moment-timezone';
import { isUndefined, isNull } from 'lodash'
import IntlMessages from 'util/IntlMessages';
import { injectIntl, defineMessages } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
    datepicker: {
      margin: "2px 0px 2px 0px",
      height: "60px",
      // width: 'fit-content',
      padding: "20px 15px 10px",
      borderBottom: "2px solid blue",
      backgroundColor: "#fff",
      color: "#2c2c2c",
      width: 300,
      fontWeight: 600
    }
}));
function StartDate(props) {
    const classes = useStyles();
    const placeholder = props.intl.formatMessage({ id: 'Date.Placeholder' });
    const [Value,setValue] = React.useState(props.endDate)
    const handleChange=(date)=>{
        //console.log(date)
        let ndate = moment(date).tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm");
        console.log(ndate)
        setValue(date)
        props.onchangeHanelEvent("endDatetime",ndate)
    }
    React.useEffect(()=>{
        console.log(props.endDate)
        console.log(new Date(props.endDate))
        console.log(moment(props.endDate))
        
        if(!isNull(props.endDate)) setValue(moment(props.endDate))
        if(isNull(props.endDate)) setValue(props.endDate)
    },[props.endDate])

    //console.log(Value,"123331")
    return (
        <div>
           <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
               <Fragment>
                   <KeyboardDateTimePicker
                    inputVariant="outlined"
                    label={<IntlMessages id="date.dueDate"/>}
                    size="small"
                    cancelLabel={<IntlMessages id="Cancel"/>}
                    fullWidth
                    format="yyyy-MM-dd HH:mm"
                    variant="outlined"
                    ampm={false}
                    animateYearScrolling
                    value={Value}
                    onChange={handleChange}     
                    emptyLabel=""        
                    placeholder={placeholder}
                    clearable
                    clearLabel={<IntlMessages id="Date.delete"/>}
                    invalidDateMessage={<IntlMessages id="Date.inValid"/>}
                    KeyboardButtonProps={{
                     "class": "px-0 m-0 btn btn-sm"
                    }}            
                    />
                </Fragment>
            </MuiPickersUtilsProvider>  
        </div>
    );
}
export default injectIntl(StartDate);